import Vue from 'vue'
import Router from 'vue-router'
// import Main from './component/Main.vue'
// import Shows from './component/Shows.vue'
// import Show from './component/Show.vue'
// import Festival from './component/Festival.vue'
import User from './component/User.vue'
import Assinatura from './component/Assinatura.vue'
import Educacional from './component/Educacional.vue'
import Dashboard from './component/Dashboard.vue'
// import Policy from './component/Policy.vue'
// import SAC from './component/SAC.vue'
// import ShowVideo from './component/ShowVideo.vue'
import NotFound from './component/NotFound.vue'
// import EventShows from './component/Events.vue'
// import { getMetaTags } from './api/show'
// import EmailValidator from './component/EmailValidator.vue'

Vue.use(Router)

// Resolve NavigationDuplicated
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  mode: process.env.CORDOVA_PLATFORM ? 'hash' : 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/assinatura'
    },
    /* {
      path: '/emailValidator',
      name: 'Email validator',
      component: EmailValidator,
      props: (route) => ({ userKey: route.query.userKey })
    }, */
    /* {
      path: '/',
      name: 'user',
      component: User,
      props: (route) => ({ new: route.query.new }),
      meta: { title: 'Swiss Money' }
    }, */
    {
      path: '/usuario',
      name: 'user',
      component: User,
      props: (route) => ({ type: route.query.type }),
      meta: { title: 'Swiss Money' }
    },
    /* {
      path: '/usuario/alterar/:change',
      name: 'user-detail',
      component: User,
      props: true
    }, */
    /* {
      path: '/usuario/ingresso/:showDate',
      name: 'user-ticket',
      component: User,
      props: true
    }, */
    {
      path: '/assinatura',
      name: 'assinatura',
      component: Assinatura,
      props: (route) => ({ type: route.query.type })
    },
    {
      path: '/videos',
      redirect: '/educacional'
    },
    {
      path: '/educacional',
      name: 'educacional',
      component: Educacional,
      meta: { title: 'Educacional - Swiss Money' }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: { title: 'Dashboard - Swiss Money' }
    },
    /* {
      path: '/:businessUrl',
      name: 'shows-business',
      component: Shows,
      props: true
    },
    {
      path: '/:businessUrl/festival/:name',
      name: 'Festival',
      component: Festival,
      props: true
    },
    {
      path: '/:businessUrl/evento/:id/:name',
      redirect: '/:businessUrl/evento/:id/:name/detalhes'
    },
    {
      path: '/:businessUrl/evento/:id/:name/:status',
      name: 'show',
      component: Show,
      props: true
    }, */
    /* {
      path: '/video/:id',
      name: 'show-video',
      component: ShowVideo,
      props: true
    }, */
    {
      path: '*',
      redirect: '/conteudo/nao-encontrado'
    },
    {
      path: '/conteudo/nao-encontrado',
      name: 'nao-encontrado',
      component: NotFound,
      props: true
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.params.status && to.params.status !== 'detalhes') {
      return false
    } else {
      if (process.env.CORDOVA_PLATFORM) window.scroll(0, 0)
      else window.scroll({ top: 0, behavior: 'smooth' })
    }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) document.title = to.meta.title

  if (to.name === 'show') {
    // Key is the metatag content placeholder
    // defaultContent is the default value for the current metatag
    // reponseProp is the propierty name on the getMetaTags

    // const metas = [...document.getElementsByTagName('meta')]
    /* getMetaTags(to.params.id).then((res) => {
      if (res.facebookPixel) {
        // let script = "!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', '{{facebookPixel}}');fbq('track', 'PageView');"
        // <img height=\"1\" width=\"1\" style=\"display:none\"src=\"https://www.facebook.com/tr?id={{facebookPixel}}&ev=PageView&noscript=1\"/>"

        // script = script.replace(/{{facebookPixel}}/g, res.facebookPixel)

        const head = document.getElementsByTagName('body')[0]
        let child = document.createElement('div')
        child.innerHTML = script
        child = child.firstChild
        head.appendChild(child)

        // let pixel = document.getElementById('scptkt')
        // pixel.innerHTML = script

        // const imgFacebook = [...document.getElementsByTagName('noscript')][0].innerHTML
        // console.log(imgFacebook)
        // imgFacebook.replace(/{{facebokPixelId}}/g, res.facebookPixel)
        // window.fbq('set', 'autoConfig', false, res.facebookPixel)
        // window.fbq('init', res.facebookPixel)
        // window.fbq('track', 'PageView')
      } else {
        // window.fbq('init', '335484230460258')
      }
      metas.filter(x => x.content === '{{META_TITLE}}').forEach(x => {
        x.content = `${res.name} - Swiss Money`
      })
      metas.filter(x => x.content === '{{META_DESCRIPTION}}').forEach(x => {
        x.content = `${
          res.description ? res.description.replace(/<\/?[^>]+(>|$)/g, '').substr(0, 300) + '...'
            : 'O melhor de entretenimento em um único aplicativo! Aplicativo para divulgar eventos de shows, teatros, musicais, palestras e muito mais. Tudo em um único aplicativo.'}`
      })
      metas.filter(x => x.content === '{{META_KEYWORDS}}').forEach(x => {
        x.content = `${String(res.name).toLowerCase()},${String(res.type).toLowerCase()},tiketera,ticket,entretenimento,teatros,shows,eventos,musicais,palestras,aplicativo,ingressos`
      })
      metas.filter(x => x.content === '{{META_AUTHOR}}').forEach(x => {
        x.content = 'Swiss Money'
      })
      metas.filter(x => x.content === '{{META_NAME}}').forEach(x => {
        x.content = 'Swiss Money'
      })
      metas.filter(x => x.content === '{{META_IMAGE}}').forEach(x => {
        if (res.images.length) {
          x.content = process.env.VUE_APP_IMG + '/' + res.business + '/' + res.id + '/' + res.images[0]
        } else {
          x.content = process.env.VUE_APP_URL_SITE + '/img/metatag.png'
        }
      })
      metas.filter(x => x.content === '{{META_URL}}').forEach(x => {
        x.content = process.env.VUE_APP_URL_SITE + to.path
      })
    }).catch(error => {
      // metas.filter(x => x.content === '{{FACEBOOK_PIXEL}}').forEach(x => { x.content = null })
      metas.filter(x => x.content === '{{META_TITLE}}').forEach(x => { x.content = `Swiss Money` })
      metas.filter(x => x.content === '{{META_DESCRIPTION}}').forEach(x => { x.content = 'O melhor de entretenimento em um único aplicativo! Aplicativo para divulgar eventos de shows, teatros, musicais, palestras e muito mais. Tudo em um único aplicativo.' })
      metas.filter(x => x.content === '{{META_KEYWORDS}}').forEach(x => { x.content = `tiketera,ticket,entretenimento,teatros,shows,eventos,musicais,palestras,aplicativo,ingressos` })
      metas.filter(x => x.content === '{{META_AUTHOR}}').forEach(x => { x.content = 'Swiss Money' })
      metas.filter(x => x.content === '{{META_NAME}}').forEach(x => { x.content = 'Swiss Money' })
      metas.filter(x => x.content === '{{META_IMAGE}}').forEach(x => { x.content = process.env.VUE_APP_URL_SITE + '/img/metatag.png' })
      metas.filter(x => x.content === '{{META_URL}}').forEach(x => { x.content = process.env.VUE_APP_URL_SITE + to.path })
      throw error
    }) */
  }
  next()
})

export default router
